import { action, computed, thunk } from "easy-peasy";
import API from "API";

export const ACTION_TYPES = {
  FAILED: 1,
  FINISHED: 2,
  FETCHING_DATA: 5,
  FETCHED_DATA: 6,
  CREATED_DATA: 7,
  UPDATED_DATA: 8,
  REMOVED_DATA: 9,
  CREATING_DATA: 10,
  UPDATING_DATA: 11,
  REMOVING_DATA: 12,
  RESTORING_DATA: 13,
  RESTORED_DATA: 14,
};

const GeneralCRUDModel = (api) => {
  return {
    process: null,
    error: null,
    data: [],
    record: null,
    response: null,
    showArchived: false,

    setRecord: action((state, payload) => {
      state.record = payload;
    }),

    setResponse: action((state, payload) => {
      state.response = payload;
    }),

    setProcess: action((state, payload) => {
      state.process = payload;
    }),

    setError: action((state, payload) => {
      state.error = payload;
      state.process = ACTION_TYPES.FAILED;
    }),

    setData: action((state, payload) => {
      state.data = payload;
    }),

    setShowArchived: action((state, payload) => {
      state.showArchived = payload;
    }),

    fetch: thunk(async (actions, payload, { getState }) => {
      actions.setProcess(ACTION_TYPES.FETCHING_DATA);
      try {
        let url = api;
        if (api.hasOwnProperty("url")) url = api.url;

        const state = getState();
        let params = state.showArchived
          ? { params: { ...payload, state: "DELETED" } }
          : { params: { ...payload, state: "ACTIVE" } };

        const data = await API.get(url, params);
        actions.setData(data);
        actions.setProcess(ACTION_TYPES.FETCHED_DATA);
      } catch (error) {
        console.error("Error while fetching data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    search: thunk(async (actions, payload, { getState, getStoreState }) => {
      actions.setProcess(ACTION_TYPES.FETCHING_DATA);
      try {
        const state = getState();
        let params = state.showArchived
          ? { params: { ...payload, state: "DELETED" } }
          : { params: { ...payload, state: "ACTIVE" } };

        const data = await API.get(api + "/search", params);
        actions.setData(data);
        actions.setProcess(ACTION_TYPES.FETCHED_DATA);
        return data;
      } catch (error) {
        console.error("Error while fetching data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    searchHelp: thunk(async (actions, payload, helpers) => {
      actions.setProcess(ACTION_TYPES.FETCHING_DATA);
      try {
        const data = await API.get(api + "/searchhelp", { params: payload });
        actions.setData(data);
        actions.setProcess(ACTION_TYPES.FETCHED_DATA);
        return data;
      } catch (error) {
        console.error("Error while fetching data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    fetchDeletedRecords: thunk(async (actions, payload) => {
      actions.setProcess(ACTION_TYPES.FETCHING_DATA);
      try {
        const data = await API.get(`${api}/deletedrecords`);
        actions.setData(data);
        actions.setProcess(ACTION_TYPES.FETCHED_DATA);
        return data;
      } catch (error) {
        console.error("Error while creating data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    fetchDeletedRecord: thunk(async (actions, payload) => {
      actions.setProcess(ACTION_TYPES.FETCHING_DATA);
      try {
        const data = await API.get(`${api}/deletedrecords/${payload.id}`);
        actions.setRecord(data);
        actions.setProcess(ACTION_TYPES.FETCHED_DATA);
        return data;
      } catch (error) {
        console.error("Error while creating data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    fetchSingle: thunk(async (actions, payload) => {
      actions.setProcess(ACTION_TYPES.FETCHING_DATA);
      try {
        const data = await API.get(`${api}/${payload.id}`);
        actions.setRecord(data);
        actions.setProcess(ACTION_TYPES.FETCHED_DATA);
        return data;
      } catch (error) {
        console.error("Error while creating data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    create: thunk(async (actions, payload) => {
      actions.setProcess(ACTION_TYPES.CREATING_DATA);
      try {
        const result = await API.post(api, payload);
        actions.setProcess(ACTION_TYPES.CREATED_DATA);
        actions.setResponse(result);
        return result;
      } catch (error) {
        console.error("Error while creating data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    update: thunk(async (actions, payload) => {
      actions.setProcess(ACTION_TYPES.UPDATING_DATA);
      try {
        const result = await API.put(api + "/" + payload.id, payload);
        actions.setProcess(ACTION_TYPES.UPDATED_DATA);
        actions.setResponse(result);
        return result;
      } catch (error) {
        console.error("Error while updating data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    remove: thunk(async (actions, payload) => {
      actions.setProcess(ACTION_TYPES.REMOVING_DATA);
      try {
        await API.delete(api + "/" + payload.id, { params: payload });
        actions.setProcess(ACTION_TYPES.REMOVED_DATA);
      } catch (error) {
        console.error("Error while updating data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),

    restore: thunk(async (actions, payload) => {
      actions.setProcess(ACTION_TYPES.RESTORING_DATA);
      try {
        const result = await API.put(
          `${api}/${payload.id}/returnArchive`,
          null,
          {
            params: payload,
          }
        );
        actions.setProcess(ACTION_TYPES.RESTORED_DATA);
        actions.setResponse(result);
        return result;
      } catch (error) {
        console.error("Error while updating data -> ", error);
        actions.setError(error);
      }
      actions.setProcess(ACTION_TYPES.FINISHED);
    }),
  };
};

export default GeneralCRUDModel;
